import DatePicker from 'react-datepicker'
import {TextArea, Form, Button, Dropdown, Label, Grid, Segment, Icon, Accordion} from "semantic-ui-react";

import 'react-datepicker/dist/react-datepicker.css';

import React from "react";
import moment from 'moment';

// Robustly coerce a field value to a moment. The value can arrive as a moment
// (initial wizard state / quick-set buttons), a Date, or a string in either
// "YYYY.MM.DD" or "DD.MM.YYYY" (the latter is what convertDate stores back into
// redux on Next). Parse strictly against the known formats so a round-trip
// through the wizard doesn't reinterpret e.g. "29.09.2026" as "2029.09.20".
const toMoment = (v) => {
    if (!v) return null;
    if (moment.isMoment(v)) return v;
    if (v instanceof Date) return moment(v);
    const m = moment(v, ['YYYY.MM.DD', 'DD.MM.YYYY', moment.ISO_8601], true);
    return m.isValid() ? m : null;
};


export default class KDatePicker extends React.Component {
    // static propTypes = {
    //     input: PropTypes.shape({
    //         onChange: PropTypes.func,
    //         value: PropTypes.object,
    //     }).isRequired,
    //     meta: PropTypes.shape({
    //         touched: PropTypes.bool,
    //         error: PropTypes.object,
    //     }).isRequired,
    //     inputValueFormat: PropTypes.string,
    // };

    static defaultProps = {
        inputValueFormat: null,
    };

    state = {
        selectedDate: null
    };

    componentWillMount() {
        if (this.props.input.value) {
            this.setState({
                selectedDate: toMoment(this.props.input.value),
            });
        }
    }

    // Keep the picker in sync when the field value is changed elsewhere
    // (e.g. the quick-set expire-date buttons dispatching redux-form change).
    componentDidUpdate(prevProps) {
        if (prevProps.input.value !== this.props.input.value) {
            this.setState({ selectedDate: toMoment(this.props.input.value) });
        }
    }

    handleChange = (date) => {
        this.setState({
            selectedDate: date,
        });

        this.props.input.onChange(date);
    }

    handleBlur = (date)  => {
        this.props.input.onBlur(date);
    }

    render() {
        const {
            meta: { touched, error },
            ...rest
        } = this.props;

        return ( <React.Fragment>
                 <Form.Input {...rest} control={DatePicker}
                                dateFormat="YYYY.MM.DD"
                                selected={this.state.selectedDate}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                                minDate={rest.minDate} label={rest.label} showYearDropdown={true} />
                {touched && error && <Label basic color='red' pointing>{error}</Label>}
            </React.Fragment>

        );
    }
}


